import { put, takeEvery } from 'redux-saga/effects';
import SuperFetch from 'library/helpers/superFetch';
import { inventoryActions } from './slice';

export function* loadInventoryLocksData() {
	const type = 'ttlock';

	const data = yield SuperFetch.get('/inventories/TTlock', {}, { type }).then((res) => {
		if (res.statusCode === 200) {
			return res.data;
		} else {
			return res;
		}
	});
	if (!data.error) {
		yield put(inventoryActions.loadInventoryLocksSuccess(data));
	} else {
		yield put(inventoryActions.loadInventoryLocksError());
		Notification('error', data.error.message);
	}
}

export function* loadInventoryGatewaysData() {
	const type = 'gateway';
	const data = yield SuperFetch.get('/inventories/TTlock', {}, { type }).then((res) => {
		if (res.statusCode === 200) {
			return res.data;
		} else {
			return res;
		}
	});
	if (!data.error) {
		yield put(inventoryActions.loadInventoryGatewaysSuccess(data));
	} else {
		yield put(inventoryActions.loadInventoryGatewaysError());
		Notification('error', data.error.message);
	}
}

export default function* inventorySaga() {
	yield takeEvery(inventoryActions.loadInventoryLocks, loadInventoryLocksData);
	yield takeEvery(inventoryActions.loadInventoryGateways, loadInventoryGatewaysData);
}
